import { __decorate, __extends } from "tslib";
import { attachShadowTemplate, coerceBoolean, coerceNumber, CustomElement, FoundationProperty, upgradeProperty } from '@tyler-components-web/core';
import { tylIconModeEdit, tylIconWarning, tylIconCheck, tylIconBlock } from '@tylertech/tyler-icons/standard';
import { StepAdapter } from './step-adapter';
import { STEP_CONSTANTS } from './step-constants';
import { StepFoundation } from './step-foundation';
import { TylerIconRegistry, IconComponent } from '../../icon';
var template = require('./step.html');
var styles = require('./step.css');
var StepComponent = /** @class */ (function (_super) {
    __extends(StepComponent, _super);
    function StepComponent() {
        var _this = _super.call(this) || this;
        TylerIconRegistry.define([
            tylIconModeEdit,
            tylIconCheck,
            tylIconWarning,
            tylIconBlock
        ]);
        attachShadowTemplate(_this, STEP_CONSTANTS.elementName, template, styles);
        _this._foundation = new StepFoundation(new StepAdapter(_this));
        return _this;
    }
    Object.defineProperty(StepComponent, "observedAttributes", {
        get: function () {
            return [
                STEP_CONSTANTS.attributes.COMPLETED,
                STEP_CONSTANTS.attributes.EDITABLE,
                STEP_CONSTANTS.attributes.ERROR,
                STEP_CONSTANTS.attributes.INDEX,
                STEP_CONSTANTS.attributes.SELECTED,
                STEP_CONSTANTS.attributes.ALTERNATIVE,
                STEP_CONSTANTS.attributes.DISABLED,
                STEP_CONSTANTS.attributes.VERTICAL,
                STEP_CONSTANTS.attributes.EXPANDED,
                STEP_CONSTANTS.attributes.IGNORE_USER_EXPANSION,
            ];
        },
        enumerable: true,
        configurable: true
    });
    StepComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'index');
        upgradeProperty(this, 'editable');
        upgradeProperty(this, 'completed');
        upgradeProperty(this, 'error');
        upgradeProperty(this, 'selected');
        upgradeProperty(this, 'alternative');
        upgradeProperty(this, 'disabled');
        upgradeProperty(this, 'vertical');
        upgradeProperty(this, 'expanded');
        upgradeProperty(this, 'ignoreUserExpansion');
    };
    StepComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    StepComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    StepComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case STEP_CONSTANTS.attributes.INDEX:
                this.index = coerceNumber(newValue);
                break;
            case STEP_CONSTANTS.attributes.COMPLETED:
                this.completed = coerceBoolean(newValue);
                break;
            case STEP_CONSTANTS.attributes.EDITABLE:
                this.editable = coerceBoolean(newValue);
                break;
            case STEP_CONSTANTS.attributes.ERROR:
                this.error = coerceBoolean(newValue);
                break;
            case STEP_CONSTANTS.attributes.SELECTED:
                this.selected = coerceBoolean(newValue);
                break;
            case STEP_CONSTANTS.attributes.ALTERNATIVE:
                this.alternative = coerceBoolean(newValue);
                break;
            case STEP_CONSTANTS.attributes.DISABLED:
                this.disabled = this.hasAttribute(STEP_CONSTANTS.attributes.DISABLED);
                break;
            case STEP_CONSTANTS.attributes.VERTICAL:
                this.vertical = this.hasAttribute(STEP_CONSTANTS.attributes.VERTICAL);
                break;
            case STEP_CONSTANTS.attributes.EXPANDED:
                this.expanded = this.hasAttribute(STEP_CONSTANTS.attributes.EXPANDED);
                break;
            case STEP_CONSTANTS.attributes.IGNORE_USER_EXPANSION:
                this.ignoreUserExpansion = this.hasAttribute(STEP_CONSTANTS.attributes.IGNORE_USER_EXPANSION);
                break;
        }
    };
    Object.defineProperty(StepComponent.prototype, "alternative", {
        get: function () {
            return this._foundation.alternative;
        },
        set: function (value) {
            this._foundation.alternative = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepComponent.prototype, "index", {
        get: function () {
            return this._foundation.index;
        },
        set: function (value) {
            this._foundation.index = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepComponent.prototype, "editable", {
        get: function () {
            return this._foundation.editable;
        },
        set: function (value) {
            this._foundation.editable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepComponent.prototype, "completed", {
        get: function () {
            return this._foundation.completed;
        },
        set: function (value) {
            this._foundation.completed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepComponent.prototype, "error", {
        get: function () {
            return this._foundation.error;
        },
        set: function (value) {
            this._foundation.error = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepComponent.prototype, "selected", {
        get: function () {
            return this._foundation.selected;
        },
        set: function (value) {
            this._foundation.selected = value;
        },
        enumerable: true,
        configurable: true
    });
    StepComponent.prototype.focus = function () {
        this._foundation.focus();
    };
    StepComponent.prototype.setStepTabIndex = function (index) {
        this._foundation.setStepTabIndex(index);
    };
    __decorate([
        FoundationProperty()
    ], StepComponent.prototype, "disabled", void 0);
    __decorate([
        FoundationProperty()
    ], StepComponent.prototype, "vertical", void 0);
    __decorate([
        FoundationProperty()
    ], StepComponent.prototype, "expanded", void 0);
    __decorate([
        FoundationProperty()
    ], StepComponent.prototype, "ignoreUserExpansion", void 0);
    StepComponent = __decorate([
        CustomElement({
            name: STEP_CONSTANTS.elementName,
            dependencies: [
                IconComponent
            ]
        })
    ], StepComponent);
    return StepComponent;
}(HTMLElement));
export { StepComponent };
